var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 11H24V13H0z","transform":"rotate(45 13.4 8.55)","key":0}),React.createElement("path",{"d":"M11 0H13V24H11z","transform":"rotate(45 13.4 8.55)","key":1})]));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Close;

Close.default = Close;
